import styled from 'styled-components';

export const StyledChatThread = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .chat-row {
    display: flex;
    gap: 10px;
    align-items: flex-end;
    max-width: 100%;
    justify-content: flex-start;
    animation: chat-appear 0.35s ease-out backwards;
  }
  .chat-row--user { justify-content: flex-end; }
  .chat-row--claude { justify-content: flex-start; }
  .chat-row--typing { justify-content: flex-start; }
  .chat-row:nth-child(1) { animation-delay: 0.10s; }
  .chat-row:nth-child(2) { animation-delay: 0.35s; }
  .chat-row:nth-child(3) { animation-delay: 0.80s; }
  .chat-row:nth-child(4) { animation-delay: 1.05s; }
  .chat-row:nth-child(5) { animation-delay: 1.50s; }
  .chat-row:nth-child(6) { animation-delay: 1.75s; }

  @keyframes chat-appear {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }

  .chat-bubble {
    padding: 8px 12px;
    border-radius: 14px;
    max-width: 78%;
    font-size: 13px;
    line-height: 1.5;
  }
  .chat-bubble--user {
    background: #f1f2f3;
    color: #303030;
    border-bottom-right-radius: 4px;
  }
  .chat-bubble--claude {
    background: #fef3ec;
    color: #303030;
    border-bottom-left-radius: 4px;
  }

  .claude-avatar-small {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #fadcc8;
    display: grid;
    place-items: center;
    flex-shrink: 0;
    overflow: hidden;
    svg { width: 70%; height: 70%; display: block; }
  }

  .typing-dots {
    display: inline-flex;
    gap: 4px;
    align-items: center;
    padding: 12px 14px;
    background: #fef3ec;
    border-radius: 14px;
    border-bottom-left-radius: 4px;
  }
  .typing-dots span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #D97757;
    opacity: 0.35;
    animation: typing-bounce 1.2s infinite;
  }
  .typing-dots span:nth-child(1) { animation-delay: 0s; }
  .typing-dots span:nth-child(2) { animation-delay: 0.15s; }
  .typing-dots span:nth-child(3) { animation-delay: 0.3s; }

  @keyframes typing-bounce {
    0%, 70%, 100% { opacity: 0.35; transform: translateY(0); }
    35% { opacity: 1; transform: translateY(-3px); }
  }
`;
